module.exports = __webpack_public_path__ + "img/img-a7fb6418.2418a928.png";